<div class="points-summary-bar d-flex justify-content-between d-lg-none">
  <!-- Back Button -->

  <div class="text-white cursor-pointer btn-circle-gloss bg-glass" (click)="goBack()">
    <span class="material-icons pe-1">arrow_back_ios_new</span>
  </div>
  <!-- Points Bar -->
  <ng-container *notInPopulation="[populations.U18]">
    <div class="justify-content-center flex-grow-1 flex-shrink-1 h-100">
      <fgb-points-summary></fgb-points-summary>
    </div>
  </ng-container>
</div>
